import { HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of, catchError, map, switchMap } from 'rxjs';
import { sessionActions } from '../actions/session.actions';
import { HttpService } from '../services/http.service';
import { finalizeLoader } from '@app/shared/components';

@Injectable()
export class SessionEffects {
    private readonly actions = inject(Actions);
    private readonly httpService = inject(HttpService);

    getSession$ = createEffect(() => {
        return this.actions.pipe(
            ofType(sessionActions.getSession),
            switchMap(() => {
                return this.httpService.getSession().pipe(
                    finalizeLoader('session-get'),
                    map((payload) => sessionActions.getSessionSuccess({ payload })),
                    catchError((response: HttpErrorResponse) => of(sessionActions.getSessionError({ code: response.status }))),
                );
            }),
        );
    });
}
